import Accordion from "../components/accordion/Accordion";
import { Container } from "./Dashboard";
import Header from "../components/header/Header";
import { productGuide } from "../constants";
import styles from "./pages.module.css";

const ProductGuide = () => {
	return (
		<Container>
			<Header>App Guide</Header>
			<div style={{ maxWidth: "500px", margin: "2rem auto" }}>
				{productGuide.map((guide, i) => (
					<Accordion key={i + 1} title={guide.name}>
						<div className={styles.guide_wrapper}>
							<h2>{guide.description}</h2>

							<p className={styles.guide_note}>
								Note: {guide.note}
							</p>
							<h3>Steps:</h3>

							{guide.steps?.automatic && (
								<>
									<h3>Automatic</h3>
									<ul>
										{guide.steps?.automatic?.map(
											(step, i) => (
												<li key={i + 1}>{step}</li>
											)
										)}
									</ul>
								</>
							)}
							{guide.steps?.batch && (
								<>
									<h3>Batch</h3>
									<ul>
										{guide.steps?.batch?.map((step, i) => (
											<li key={i + 1}>{step}</li>
										))}
									</ul>
								</>
							)}
							{guide.steps?.base && (
								<>
									<ul>
										{guide.steps?.base?.map((step, i) => (
											<li key={i + 1}>{step}</li>
										))}
									</ul>
								</>
							)}
						</div>
					</Accordion>
				))}
			</div>
		</Container>
	);
};

export default ProductGuide;
